module.exports = __webpack_public_path__ + "static/media/stonks_blue.cde50f4c.svg";